<div class="chart-container">
  <canvas id="barChart"></canvas>
  <button
    mat-raised-button
    color="primary"
    (click)="toggleFullScreen()"
    *ngIf="!isFullScreen"
  >
    フルスクリーン
  </button>
</div>
